export const deleteModelAvailability = `mutation($input: DeleteModelAvailabilityRequest!) {
    deleteModelAvailability(input: $input) {
        message
    }
}`;

export const deleteMaterialAvailability = `mutation($input: DeleteMaterialAvailabilityRequest!) {
    deleteMaterialAvailability(input: $input) {
        message
    }
}`;

export const deleteServiceAvailability =`mutation DeleteServiceAvailability($input: DeleteServiceAvailabilityRequest!) {
  deleteServiceAvailability(input: $input) {
    message
    isError
  }
}`;
 export const deleteParameter = `mutation DeleteParameter($input: DeleteParametersRequest!) {
  deleteParameter(input: $input) {
    message
  }
}`

export const deleteLocalizationAvailability = `mutation DeleteLocalizationAvailability($input: DeleteLocalizationAvailabilityRequest!) {
  deleteLocalizationAvailability(input: $input) {
    message
  }
}`

export const deleteDefaultLocal =`mutation DeleteDefaultLocal($input: DeleteDefaultLocalRequest!) {
  deleteDefaultLocal(input: $input) {
    message
    response
  }
}`

export const deleteParametersLocalization = `mutation DeleteParametersLocalization($input: DeleteParametersRequest!) {
  deleteParametersLocalization(input: $input) {
    message
  }
}`